// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__GUAMU","overlay":"Loader_overlay__nos91","spinner":"Loader_spinner__E1GtZ","rotation":"Loader_rotation__L3zpA"};